import IconButtonWithTooltip from './IconButtonWithTooltip';

export default IconButtonWithTooltip;
